import styled from 'styled-components';
import resume from '../../../assets/resume_Parth Hingu.pdf';
// import useFetchAnalytics from '../../../utils/useFetchAnalytics';
import { ReactComponent as ArrowIcon } from '../../../assets/arrowRight.svg';
import { useTheme } from '../../../context/ThemeContext';
import { ReactComponent as DownloadIcon } from '../../../assets/download.svg';

const ContactTile = () => {
  // const { totalVisitors } = useFetchAnalytics();
  const { isDarkMode } = useTheme();

  return (
    <Wrapper>
      <HeaderWrapper>
        <Header>Let's work together!</Header>
        <ContactMessage>
          Just send an email. I’d love to join your team for the next project to
          build great products together!
        </ContactMessage>
      </HeaderWrapper>
      <ButtonWrapper>
        <Link darkMode={isDarkMode} href='mailTo:hinguparth23@gmail.com'>
          <IconArrow />
          <ButtonText>Contact Me</ButtonText>
        </Link>
        <DownloadLink
          darkMode={isDarkMode}
          href={resume}
          target='_blank'
          rel='noreferrer'
        >
          <IconDownload />
          <ButtonText>Resume</ButtonText>
        </DownloadLink>

        <Date>
          <strong>
            # of Visits: <span>{300}</span>
          </strong>
        </Date>
      </ButtonWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 40px 44px;

  @media (max-width: 500px) {
    padding: 20px 22px;
    align-items: center;
    gap: 16px;
  }
`;

const IconArrow = styled(ArrowIcon)`
  transform: rotate(-45deg);
  color: ${({ theme }) => theme.text};
  height: 40px;
  width: 40px;
  margin-top: 6px;
`;

const IconDownload = styled(DownloadIcon)`
  color: ${({ theme }) => theme.text};
  height: 50%;
  width: 30%;
`;

const Header = styled.h1`
  line-height: 32px;
  font-weight: 400;
  font-family: 'Bashing';
  font-size: calc(40 / 16 * 1rem);
  margin-bottom: 8px;
`;

const ContactMessage = styled.p`
  font-size: 1rem;
  line-height: 26px;
  letter-spacing: 0.5px;
  font-weight: 400;
  display: flex;
  text-align: left;
  @media (max-width: 500px) {
    text-align: center;
  }
`;

const Link = styled.a`
  height: 36px;
  padding: 0px 12px 0px 3px;
  gap: 8px;
  border-radius: 18px;
  border: ${({ theme }) => theme.border};
  background: ${({ theme, darkMode }) =>
    darkMode ? theme.tileBackground : 'transparent'};
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const DownloadLink = styled(Link)`
  width: 30%;
  @media (max-width: 500px) {
    display: none;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 500px) {
    align-items: center;
  }
`;

const ButtonText = styled.p`
  color: ${({ theme }) => theme.text};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  font-weight: 400;
`;

const ButtonWrapper = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  width: 100%;
  span {
    color: hsl(23, 91%, 52%);
  }
`;

const Date = styled.p`
  color: ${({ theme }) => theme.text};
`;

export default ContactTile;
